import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function Participant() {
  const { conversationId, participantId } = useParams();
  const [participantData, setParticipantData] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');
  const [showRecaptcha, setShowRecaptcha] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setStatusMessage('Loading...');
    const fetchParticipantData = async () => {
      try {
        const response = await fetch(`/check`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ conversationId, participantId }),
        });

        if (isMounted) {
          console.log('Response status:', response.status);
          const responseBody = await response.text();

          if (response.ok) {
            setStatusMessage('Participant OK');
            setShowRecaptcha(true);
          } else {
            setStatusMessage('Link incorrect');
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error fetching participant data:', error);
          setStatusMessage('Link incorrect');
        }
      }
    };

    fetchParticipantData();

    return () => {
      isMounted = false;
    };
  }, [conversationId, participantId]);

  if (!participantData) {
    return (
      <div>
        <div>{statusMessage}
        {showRecaptcha && (
        <div>
          <form action="?" method="POST">
            <div className="g-recaptcha" data-sitekey="6LedKsQqAAAAADDFUZ1wYUu-ECCCrM6P4WLJw985"></div>
            <br />
            <input type="submit" value="I'm not a robot" />
          </form>
          <script src="https://www.google.com/recaptcha/api.js" async defer></script>
        </div>
      )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>Details</h1>
      {/* Render other participant details */}
      <div>{statusMessage}</div>
    </div>
  );
}

export default Participant;